import angular from 'angular';
import {
  scrollY,
  offsetTop,
  offsetBottom,
  elementHeight,
  animateScrollTop,
} from '@cian/ui/app/services/dom-utils';

import { getSearchParams } from '../../scripts/utils';

export default [
  '$scope',
  '$document',
  '$window',
  '$element',
  'adSegmentsService',
  'navigationService',
  '$rootScope',
  'analyticsService',
  function ($scope, $document, $window, $element, adSegmentsService, navigationService, $rootScope, analyticsService) {
    const document = $document[0];
    const documentElement = document.documentElement;

    let currentItemId = 'ad-type';
    let currentItemLocked = false;
    let animation;
    let previousScrollPosition;

    $scope.$watchCollection(() => this.segments, segments => {
      navigationService.watchSegments(segments);
      this.links = navigationService.links;
    });

    this.isActive = function (link) {
      return link.id === currentItemId;
    };

    this.clearForm = () => {
      animateScrollTop({
        to: 0,
        duration: 500,
        done: () => {

        },
      });
      this.clearAction();
      analyticsService.clearForm();
    };

    // Scrolling

    const switchActiveItem = () => {
      const scrollPosition = scrollY();

      if (previousScrollPosition !== scrollPosition) {
        // Ищем каждый раз, потому что состав и высота сегментов могут меняться
        const segmentElements = document.querySelectorAll('.js-segment');
        const totalSegments = segmentElements.length;
        Array.prototype.forEach.call(segmentElements, (segmentElement, index) => {
          const segmentTop = offsetTop(segmentElement);

          // Для первого сегмента не проверяем верхнюю границу
          // (считаем его верхом начало страницы)
          if (index === 0 || scrollPosition >= segmentTop) {
            const segmentBottom = segmentTop + segmentElement.offsetHeight;

            // Для последнего сегмента не проверяем нижнюю границу
            // (считаем его низом конец страницы)
            if (
              index === totalSegments - 1 ||
              scrollPosition < segmentBottom
            ) {
              if (currentItemId !== segmentElement.id) {
                $scope.$evalAsync(() => { currentItemId = segmentElement.id; });
              }

              // Break loop
              return false;
            }
          }

          return false;
        });
        previousScrollPosition = scrollPosition;
      }
    };

    const switchActiveItemOnScroll = () => {
      previousScrollPosition = scrollY();
      $document.on('scroll', switchActiveItem);
    };

    switchActiveItemOnScroll();

    const addFormNav = $element.parent()[0];
    const pinNavigation = () => {
      // Pin navigation
      const scrollLeft = addFormNav.getBoundingClientRect().left; // scrollbar width fix
      const isBottomPinned = (scrollY() + elementHeight($element[0])) > offsetBottom(addFormNav);
      if (scrollY() > offsetTop(addFormNav) && !isBottomPinned) {
        $element.removeClass('state_bottom_pinned');
        $element.addClass('state_pinned');
        $element.css({
          left: `${scrollLeft}px`,
        }); // fiexd element horizontal scroll
      } else {
        $element.removeClass('state_pinned');
        $element.css({
          left: 0,
        });
        if (isBottomPinned) {
          $element.addClass('state_bottom_pinned');
        } else {
          $element.removeClass('state_bottom_pinned');
        }
      }
    };

    this.isVerified = navigationService.isVerified;

    $document.on('scroll', pinNavigation);
    angular.element($window).on('resize', pinNavigation);
    // в случае изменения высоты контента вызываем перерисовку
    $scope.$watch(() => $document[0].getElementById('content').clientHeight, () => $scope.$applyAsync(pinNavigation));

    this.goTo = function (link) {
      currentItemId = link.id;

      // Prevent active item from switching while smooth scrolling
      if (!currentItemLocked) {
        $document.off('scroll', switchActiveItem);
      }
      currentItemLocked = true;

      if (animation) {
        animation.cancel();
        animation = null;
      }

      // Для ЖК нам нужно переименовать сегмент адреса, так как он переименован и в навигации
      const segmentKey = link.id === 'address' && this.category === 'newBuildingFlatSale' ? 'address-jk' : link.id;

      analyticsService.trackNavigationClick(segmentKey);

      // Smooth scroll
      animation = animateScrollTop({
        to: Math.min(
          offsetTop(document.getElementById(link.id)),
          documentElement.scrollHeight - documentElement.clientHeight
        ),
        duration: 600,
        done: () => {
          if (currentItemLocked) {
            switchActiveItemOnScroll();
          }
          currentItemLocked = false;
          animation = null;
        },
      });
    };

    $rootScope.$on('scrollTo', (_, id) => {
      this.goTo({ id });
    });

    window.addEventListener('load', () => {
      const queryParams = getSearchParams();

      // Если в адресной строке передан параметр link со значением из списка навигации,
      // скроллим до нужного блока
      if (queryParams && 'link' in queryParams &&
        Object.keys(navigationService.textBySegment).indexOf(queryParams.link) >= 0
      ) {
        this.goTo({ id: queryParams.link });
      }
    });
  },
];
